import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  wrapper: {
    maxWidth: 899,
    minWidth: 899,
    minHeight: 1150,
    maxHeight: 1150,
    padding: 64,
    paddingBottom: 59,

    background: Colors.White,
    position: 'relative',
  },
  exportWrapper: {
    position: 'fixed',
    left: -10000,
    top: 0,
    overflow: 'visible',
    pointerEvents: 'none',
    opacity: 0,
    zIndex: -1,
  },

  buttonDownload: {
    '&.MuiButton-root': {
      minWidth: 247,
      minHeight: 48,
      padding: '12px 20px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 12,
      borderRadius: 999,
      background: 'rgba(0, 0, 0, 0.70)',
      position: 'absolute',
      left: '50%',
      bottom: 30,
      transform: 'translateX(-50%)',
    },
  },
  cornerTopLeft: {
    position: 'absolute',
    top: 201,
    left: 84,
    zIndex: -10,
  },
  cornerTopRight: {
    position: 'absolute',
    top: 207,
    right: 98,
    zIndex: -10,
  },
  cornerBottomRight: {
    position: 'absolute',
    bottom: 262,
    right: 96,
    zIndex: -10,
  },
  cornerBottomLeft: {
    position: 'absolute',
    bottom: 264,
    left: 99,
    zIndex: -10,
  },
  line: {
    width: '100%',
    height: 49,
    background: '#F5F5F5',
    position: 'absolute',
    top: '50%',
    left: 0,
    transform: 'translateY(-50%)',
    zIndex: -10,
  },
  text_certificate_page_1: {
    color: '#404040',
    fontFamily: 'Readex Pro',
    fontSize: 10,
    fontStyle: 'normal',
    fontWeight: 200,
    lineHeight: '12px',
    letterSpacing: 0.4,

    position: 'absolute',
    top: '50%',
    right: 16,
    zIndex: -9,
    transform: 'translateY(-117px) rotate(270deg)',
    transformOrigin: 'right center',
  },
}));

export default useStyles;
